import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { TableSalesReportItem } from 'src/services/apiService/response-models/report';


interface TableSalesReportProps {
  data: TableSalesReportItem[];
}

const TableSalesReportSummary: React.FC<TableSalesReportProps> = ({ data }) => {
  return (
    <Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Table Name</TableCell>
              <TableCell>Section Name</TableCell>
              <TableCell align="right">Order Count</TableCell>
              <TableCell align="right">Total Sales</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              data.map((row) => (
                <TableRow key={row.tableId}>
                  <TableCell>{row.tableName}</TableCell>
                  <TableCell>{row.sectionName}</TableCell>
                  <TableCell align="right">{row.orderCount}</TableCell>
                  <TableCell align="right">${row.totalSales.toFixed(2)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableSalesReportSummary;
